import { TimePicker } from '../time-picker';
import { useFormFieldContext } from './form-field-context';
import { useFieldAria } from './use-field-aria';

/**
 * Time picker form control. The RHF field value is a canonical `HH:MM` string;
 * a token-styled two-column dropdown replaces the native time input's OS popup.
 */
export function FormFieldTimePicker({
  placeholder,
  className,
  disabled = false,
  minTime,
  maxTime,
  allowEndOfDay,
  allow24HourEnd,
}: {
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  /** Lower bound (`HH:MM`, exclusive) — offered times must be after it. */
  minTime?: string | undefined;
  /** Upper bound (`HH:MM`, exclusive) — offered times must be before it. */
  maxTime?: string | undefined;
  /** Read `00:00` as midnight ending the day. Set on a "closing time" field. */
  allowEndOfDay?: boolean;
  /** Offer the explicit 24:00 end-of-day value. */
  allow24HourEnd?: boolean;
}) {
  const { field } = useFormFieldContext();
  const aria = useFieldAria();

  return (
    <TimePicker
      id={aria.id}
      aria-describedby={aria['aria-describedby']}
      aria-invalid={aria['aria-invalid']}
      value={(field.value as string | undefined) ?? ''}
      onChange={field.onChange}
      onBlur={field.onBlur}
      disabled={disabled}
      {...(minTime !== undefined ? { minTime } : {})}
      {...(maxTime !== undefined ? { maxTime } : {})}
      {...(allow24HourEnd !== undefined ? { allow24HourEnd } : {})}
      {...(allowEndOfDay !== undefined ? { allowEndOfDay } : {})}
      {...(placeholder !== undefined ? { placeholder } : {})}
      {...(className !== undefined ? { className } : {})}
    />
  );
}
